import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { UrlMetadata } from 'api';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';

const styles = () =>
  createStyles({
    root: {
      fontWeight: 700, // TODO: Hack
      paddingTop: 12,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  title: UrlMetadata['title'];
}

const Title: FC<IProps> = ({ classes, title }) => (
  <Typography gutterBottom color="textPrimary" variant="h6" className={classes.root}>
    {title}
  </Typography>
);

export default withStyles(styles)(Title);
